import React from "react";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { BreadcrumbPageProps } from "../types";

function BreadcrumbPage({ className, ...props }: BreadcrumbPageProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <span
      data-slot="breadcrumb-page"
      aria-disabled="true"
      aria-current="page"
      className={cn("text-foreground font-normal", className, classes)}
      {...native}
    />
  );
}

BreadcrumbPage.displayName = "Breadcrumb.Page";

export default BreadcrumbPage;
